<template>
    <div class="wrapper">
        <ContentHeader />
        <main class="container">
            <h2 class="category-title" v-text="category.title"></h2>
            <ul class="questions">
                <li class="card question-card" v-for="(q, j) in category.q" :key="j">
                    <img class="card-img-top" :src="q.img" />
                    <div class="card-body">
                        <p class="card-title" v-text="q.text"></p>
                    </div>
                    <AnswerOptions class="card-footer" :options="category.options" :name="'ans'-j" :index="q.ansIndex" />
                </li>
            </ul>
        </main>
        <ContentFooter @goback="goBack" @gonext="goNext" :footer="body.footer" />
    </div>
</template>

<script>
import ErrorPage from './ErrorPage'
import ContentFooter from './Content/ContentFooter'
import ContentHeader from './Content/ContentHeader'
import AnswerOptions from './Common/AnswerOptions'
import axios from 'axios'

import content from '../assets/json/content.json'

export default {
    data: function () {
        return {
            content: content,
        }
    },
    props: [
        'currentPage',
        'level'
    ],
    components: {
        ContentHeader,
        ContentFooter,
        AnswerOptions,
        ErrorPage
    },
    computed: {
        body: function() {
            if(window.location.href.includes("-en")){
                return this.content.en;
            }else if(window.location.href.includes("-cn")){
                return this.content.cn;
            }else if(window.location.href.includes("-pt")){
                return this.content.pt;
            }else if(window.location.href.includes("-sn")){
                return this.content.sn;
            }else if(window.location.href.includes("-tg")){
                return this.content.tg;
            }else{
                return this.content.jp;
            }
             
            
        },
        category: function() {
            return this.buildContent(this.$props.level, this.currentPageInt);
        },
        currentPageInt: function() {
            return parseInt(this.$props.currentPage);
        }
    },
    methods: {
        goNext: function() {
            if(this.currentPageInt >= this.questions[this.$props.level].categories.length -1) {
                this.$router.push("/confirm/" + this.$props.level);
                return;
            }
            this.$router.push({path: '/content/' + this.$props.level + '/' + (this.currentPageInt + 1)});
        },
        goBack: function() {
            if(this.currentPageInt==0) {
                this.$router.push({path: '/'});
                return;
            }
            this.$router.push({path: '/content/' + this.$props.level + '/' + (this.currentPageInt - 1)});
        },
    },
    created: function () {
        // const filename = "../../static/" + this.$props.level + "/content.json";
        // this.loadJsonIfNeed(filename, true);
    }
}
</script>

<style>
    .category-title {
        margin-top: 10px;
        text-align: center;
    }

    .questions {
        list-style: none;
    }

    .question-card {
        width: 500px;
        margin-top: 5px;
        margin-bottom: 5px;
        margin-left: auto;
        margin-right: auto;
    }
</style>